module.exports = __webpack_public_path__ + "img/feature-1-arizona.af9d5a08.png";